import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { GTMProvider } from '@elgorditosalsero/react-gtm-hook';

import Home from 'pages/home';
import { GlobalContextProvider } from 'contexts/global-context';
import { RouterContextProvider } from 'contexts/router-context';
import Error from 'components/error';
import { trackError } from 'utils';

// Import i18n translations config.
import 'i18n';

function App() {
  const gtmParams = { id: 'GTM-W6CJNGJ' };

  return (
    <GTMProvider state={gtmParams}>
      <ErrorBoundary FallbackComponent={Error} onError={trackError}>
        <GlobalContextProvider>
          <RouterContextProvider>
            <Home />
          </RouterContextProvider>
        </GlobalContextProvider>
      </ErrorBoundary>
    </GTMProvider>
  );
}

export default App;
